import { gql } from "@apollo/client";

export const PARTNERS_FOR_ASSOCIATION_TO_HIERARCHY_QUERY = gql`
  query partnersForAssociationToHierarchy($filterList: [PartnersForAssociationToHierarchyFilterInput]) {
    partnersForAssociationToHierarchy(filterList: $filterList) {
      id
      partnerName
      partnerTypeId
      partnerTypeName
      uniqueId
    }
  }
`;
